module.exports = __webpack_public_path__ + "img/4b39e7b3c9799bc00304e44bca49b69a.png";